import editorialStyle from "../../../components/editorial/style.scss";
import style from "./style.scss";

import { Fragment } from "preact";
import { mergeClasses } from "../../../components/helpers";
import Link, {
  ProductLink,
  Button,
  ButtonList,
  LargeViewOnly,
  StickyButtons,
  ButtonBar,
  affiliateMerchants,
} from "../../../components/link";
import AffiliateDisclosure from "../../../components/affiliate-disclosure";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import FixedTable from "../../../components/fixed-table";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import ImageSet from "../../../components/image-set";
import Image from "../../../components/image";
import YouTube from "../../../components/youtube";
import Author from "../../../components/author";
import BluettiCouponCode from "../components/coupon-code";
import NoWrap from "../../../components/no-wrap";
import SlugHeading from "../../../components/slug-heading";
import SlugLink from "../../../components/slug-link";
import Accordion from "../../../components/accordion";
import AccordionPreview from "../../../components/accordion/preview";
import PhotoListItem from "../../../components/photo-list-item";
import Tags from "../../../components/tags";
import ReviewItem from "../../../components/review-item";
import Questions from "../../../components/questions";
import namedRoutes from "../../../settings/routes";
import { lookupByUrl } from "../../../settings/route-data-lookup";

import Promo from "./promo";

import AffiliateAd from "../../../components/affiliate-ad";

//https://www.bluettipower.com/products/apex-300-home-integration-kit?variant=47844170137819
//https://www.bluettipower.com/products/fast-ev-charging-cable?variant=47351775199451

let headerInfo = lookupByUrl(namedRoutes.bluetti.apex200);

// const price = {
//   current: 899,
//   msrp: 1599,
// };

const Page = () => (
  <div>
    <Head data={headerInfo} />
    <Hero
      positionX={0}
      positionY={60}
      background="/images/backgrounds/bluetti-apex-200.webp"
      titlePrefix="BLUETTI"
      title="Apex 200"
      subTitle="Power Station Review & Comparison"
    />
    <Editorial>
      <Center>
        <Author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />

        <LargeViewOnly>
          <ButtonList size="medium">
            <Button
              size="medium"
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
              icon="Bluetti"
            >
              View on BLUETTI
            </Button>
            {/* <Button
              size="medium"
              affiliate=""
              href=""
              secondary
              icon="Amazon"
            >
              View on Amazon
            </Button> */}
          </ButtonList>
        </LargeViewOnly>

        <p>
          The <strong>BLUETTI Apex 200</strong> will launch on{" "}
          <strong>November 4</strong>, 2026. I break down its{" "}
          <strong>pros and cons</strong>, including how it compares with the
          Apex 300 and Elite 300. Since I had early access to the Apex 200, my
          goal is to help you decide whether it's the right fit for your needs.
        </p>

        <AffiliateDisclosure />

        <ImageSet
          size={4}
          maxShow={4}
          shadow
          images={[
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/front.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/front.webp",
              alt: "BLUETTI Apex 200 front view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/front-right.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/front-right.webp",
              alt: "BLUETTI Apex 200 front-right view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/front-left.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/front-left.webp",
              alt: "BLUETTI Apex 200 front-left view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/left.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/left.webp",
              alt: "BLUETTI Apex 200 left-side view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/right.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/right.webp",
              alt: "BLUETTI Apex 200 right-side view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/front-ports.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/front-ports.webp",
              alt: "BLUETTI Apex 200 front ports view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/left-ports.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/left-ports.webp",
              alt: "BLUETTI Apex 200 left-side ports view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/right-ports.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/right-ports.webp",
              alt: "BLUETTI Apex 200 right-side ports view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/back-right.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/back-right.webp",
              alt: "BLUETTI Apex 200 back-right view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/back.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/back.webp",
              alt: "BLUETTI Apex 200 back view",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/1920/back-left.webp",
              sm: "/images/products/bluetti/apex-200/photos/480/back-left.webp",
              alt: "BLUETTI Apex 200 back-left view",
            },
          ]}
        />

        {/* <ImageSet
          size={4}
          maxShow={4}
          shadow
          images={[
            {
              lg: "/images/products/bluetti/apex-200/front.webp",
              alt: "BLUETTI Apex 200 front view",
            },
            {
              lg: "/images/products/bluetti/apex-200/left.webp",
              alt: "BLUETTI Apex 200 left-side view",
            },
            {
              lg: "/images/products/bluetti/apex-200/front-right.webp",
              alt: "BLUETTI Apex 200 front-right view",
            },
            {
              lg: "/images/products/bluetti/apex-200/front-left.webp",
              alt: "BLUETTI Apex 200 front-left view",
            },
            {
              lg: "/images/products/bluetti/apex-200/front-top.webp",
              alt: "BLUETTI Apex 200 front-top view",
            },
            {
              lg: "/images/products/bluetti/apex-200/top.webp",
              alt: "BLUETTI Apex 200 top view",
            },
            {
              lg: "/images/products/bluetti/apex-200/front-right-2.webp",
              alt: "BLUETTI Apex 200 front-right view",
            },
            {
              lg: "/images/products/bluetti/apex-200/front-left-2.webp",
              alt: "BLUETTI Apex 200 front-left view",
            },
          ]}
        /> */}

        <Accordion
          items={[
            {
              heading: "Table of Contents",
              content: (
                <ol>
                  <li>
                    <SlugLink>Comparison & Specifications</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink text="BLUETTI Apex 200 vs Apex 300 vs Elite 300 Comparison Table">
                          Apex 200 Comparison Table
                        </SlugLink>
                      </li>
                      <li>
                        <SlugLink>Full Specifications</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Apex 300 Comparison</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Elite 300 Comparison</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Launch Pricing</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Highlights</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Considerations</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Apex 200 for Home Backup</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Home Integration</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>
                      Apex 200 for Vanlife, RV, and Overlanding
                    </SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Vanlife & RV System Examples</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Accessories</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Extra Batteries</SlugLink>
                      </li>
                      <li>
                        <SlugLink>AC Charging Accessories</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Alternator Chargers</SlugLink>
                      </li>
                      <li>
                        <SlugLink>DC Expansion & Fuse Block</SlugLink>
                      </li>
                      <li>
                        <SlugLink>External Display</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Solar Panels</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Suggestions to BLUETTI</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Early Verdict</SlugLink>
                  </li>
                </ol>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <YouTube id="HMkvVCDkeYw" />
      </Center>
      <Center>
        <SlugHeading tag="h2">Comparison & Specifications</SlugHeading>

        <p>
          At first glance,{" "}
          <strong>
            the Apex 200 may appear to be a smaller Apex 300, but several
            important differences set the two models apart
          </strong>
          . Instead of stripping away several features, the Apex 200 integrates
          functionality that requires expensive accessories on the Apex 300
          while also combining practical features from the Elite 300. The result
          is a distinct model with its own advantages and limitations.
        </p>

        <h3>
          BLUETTI <NoWrap>Apex 200</NoWrap> vs <NoWrap>Apex 300</NoWrap> vs{" "}
          <NoWrap>Elite 300</NoWrap> Comparison Table
        </h3>

        <Fragment>
          <FixedTable>
            <table>
              <thead>
                <tr>
                  <th class={editorialStyle.sticky}>Model</th>
                  <th>Apex 200</th>
                  <th>Apex 300</th>
                  <th>Elite 300</th>
                </tr>
              </thead>
              <tbody>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Photo</strong>
                  </th>
                  <td>
                    <Image
                      src="/images/products/bluetti/apex-200/front.webp"
                      alt="BLUETTI Apex 200"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                  <td>
                    <Image
                      src="/images/products/bluetti/apex-300/front.webp"
                      alt="BLUETTI Apex 300"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                  <td>
                    <Image
                      src="/images/products/bluetti/elite-300/front.webp"
                      alt="BLUETTI Elite 300"
                      showAlt
                      maxHeight={150}
                    />
                  </td>
                </tr>
                <tr class={editorialStyle.noHover}>
                  <th class={editorialStyle.sticky}>
                    <strong>Links</strong>
                  </th>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
                        icon="Bluetti"
                      >
                        Store
                      </Button>
                      {/* <Button
                        size="small"
                        external
                        href=""
                        secondary
                      >
                        Manual
                      </Button> */}
                    </ButtonBar>
                  </td>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/apex-300-home-battery-backup?id=68804e7e63e18b529ef2604a&variant=47351562174683"
                        icon="Bluetti"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        external
                        href="https://s4.bluettipower.com/bluetti/purchasePageBiz/2025/12/Apex%20300%20User%20%20Manual%20US%20EN-FR-1764555919287-cde9.pdf"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                  <td>
                    <ButtonBar>
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/elite-300-portable-power-station"
                        icon="Bluetti"
                      >
                        Store
                      </Button>
                      <Button
                        size="small"
                        external
                        href="https://s4.bluettipower.com/bluetti/purchasePageBiz/2026/03/Elite%20300%20User%20Manual%20US%20EN-FR-1772623629263-39f7.pdf"
                        secondary
                      >
                        Manual
                      </Button>
                    </ButtonBar>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Price</strong>
                  </th>
                  <td>
                    <NoWrap>
                      $1,099 <s>$1,399</s>
                    </NoWrap>
                  </td>
                  <td>
                    <NoWrap>
                      $1,499 <s>$2,199</s>
                    </NoWrap>
                  </td>
                  <td>
                    <NoWrap>
                      $1,199 <s>$2,299</s>
                    </NoWrap>
                  </td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>Capacity</strong>
                  </th>
                  <td>2,560Wh</td>
                  <td>2,764Wh</td>
                  <td>3,014Wh</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Extra battery</strong>
                  </th>
                  <td>6x</td>
                  <td>6x</td>
                  <td>--</td>
                </tr>
                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>AC output</strong>
                  </th>
                  <td>
                    3,200W total <br />
                    3,600W w/ battery <br />
                    4,800W surge
                  </td>
                  <td>
                    3,840W total <br />
                    7,680W surge
                  </td>
                  <td>
                    2,400W total <br />
                    4,800W surge
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>AC ports</strong>
                  </th>
                  <td>
                    x3 (20A each) <br />
                    x1 (30A)
                  </td>
                  <td>
                    x4 (20A each) <br />
                    x1 (30A) <br />
                    x1 (120/240V, 50A)
                  </td>
                  <td>
                    x4 (20A each) <br />
                    x1 (30A) <br />
                  </td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>12V cigarette port</strong>
                  </th>
                  <td>12V⎓10A, 120W</td>
                  <td>
                    Add-on <sup>1</sup>
                  </td>
                  <td>12V⎓10A</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>12V 30A port</strong>
                  </th>
                  <td>12V⎓30A, 360W</td>
                  <td>No</td>
                  <td>Yes</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>12V 50A port</strong>
                  </th>
                  <td>
                    Add-on <sup>1</sup>
                  </td>
                  <td>
                    Add-on <sup>1</sup>
                  </td>
                  <td>No</td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Low-voltage solar</NoWrap>
                    </strong>
                  </th>
                  <td>
                    12-60V⎓25A <br />
                    1,000W
                  </td>
                  <td>
                    x2 12-60V⎓20A <br />
                    1,200W
                  </td>
                  <td>
                    12-60V⎓22A <br />
                    1,200W
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>High-voltage solar</NoWrap>
                    </strong>
                  </th>
                  <td>
                    60-280V⎓16A <br />
                    2,000W
                  </td>
                  <td>--</td>
                  <td>--</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>AC input</strong>
                  </th>
                  <td>
                    15A 1,800W <sup>2</sup>
                    <br />
                    3,200W (P050A)
                  </td>
                  <td>
                    15A 1,800W <br />
                    3,840W (P050A)
                  </td>
                  <td>15A 1,800W</td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>USB C</strong>
                  </th>
                  <td>
                    1x 140W <br />
                    1x 100W
                  </td>
                  <td>
                    Add-on <sup>1</sup>
                  </td>
                  <td>2x</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>USB A</strong>
                  </th>
                  <td>2x 15W</td>
                  <td>
                    Add-on <sup>1</sup>
                  </td>
                  <td>2x</td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>Size (in)</strong>
                  </th>
                  <td>20.7 × 12.9 × 8.3"</td>
                  <td>20.7 × 12.9 × 12.6"</td>
                  <td>14.4 × 12 × 11.7</td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Size (mm)</strong>
                  </th>
                  <td>
                    <NoWrap>525 × 327 × 211</NoWrap>
                  </td>
                  <td>
                    <NoWrap>525 × 327 × 320</NoWrap>
                  </td>
                  <td>
                    <NoWrap>366 × 305 × 297</NoWrap>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Weight</strong>
                  </th>
                  <td>
                    <NoWrap>59lbs (27kg)</NoWrap>
                  </td>
                  <td>
                    <NoWrap>84lbs (38kg)</NoWrap>
                  </td>
                  <td>
                    <NoWrap>58lbs (26kg)</NoWrap>
                  </td>
                </tr>
              </tbody>
            </table>
          </FixedTable>
          <p class="caption">
            <strong>1.</strong> Requires BLUETTI{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/hub-d1-parallel-box"
            >
              Hub D1
            </Link>{" "}
            or{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/dc-hub-for-charger-2"
            >
              DC Hub
            </Link>{" "}
            +{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/bluetti-charger-2-alternator-solar-charger"
            >
              Charger 2
            </Link>{" "}
            for expanded USB and DC outputs. <strong>2.</strong> Defaults to 12A
            (1,440W). After increasing the charging limit in the BLUETTI app, my
            unit gradually ramps up and peaks at approximately 1,560W rather
            than the advertised 1,800W.
          </p>
        </Fragment>

        <hr />

        <SlugHeading tag="h3">Full Specifications</SlugHeading>
        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "General",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> Apex 200 (AP200)
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 59.3lbs (26.9kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 20.67 × 12.87 × 8.31 in (525
                      × 327 × 211 mm)
                    </li>
                    <li>
                      <strong>Warranty Period:</strong> 5 years
                    </li>
                    <li>
                      <strong>AC & DC Input:</strong> 3,200W Max (4,600W Max
                      with expansion unit)
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "AC Power",
              content: (
                <Fragment>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      AC Output:
                      <ul>
                        <li>
                          <strong>Total AC Output:</strong>
                          <ul class="circle">
                            <li>Single Unit: 3,200W Max</li>
                            <li>With Expansion Unit: 3,600W Max</li>
                          </ul>
                        </li>
                        <li>
                          <strong>Surge Power:</strong>
                          <ul class="circle">
                            <li>
                              Single Unit:
                              <ul class="disc">
                                <li>3,360–3,840W (2min)</li>
                                <li>3,840–4,800W (10s)</li>
                                <li>≥ 4,800W (0.5s)</li>
                              </ul>
                            </li>
                            <li>
                              With Expansion Unit:
                              <ul class="disc">
                                <li>3,780–4,320W (2min)</li>
                                <li>4,320–5,400W (10s)</li>
                                <li>≥ 5,400W (0.5s)</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>AC Outlets (US):</strong>
                          <ul class="circle">
                            <li>
                              NEMA 5−20R (×3): 120V, 20A Max per port, 50/60Hz
                            </li>
                            <li>
                              NEMA TT-30R (×1):
                              <ul class="disc">
                                <li>Single Unit: 3,200W Max, 120V, 50/60Hz</li>
                                <li>With Expansion Unit: 3,600W Max</li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>AC Input/Output (P050A):</strong>
                          <ul class="circle">
                            <li>Single Unit: 3,200W Max, 120V, 50/60Hz</li>
                            <li>With Expansion Unit: 3,600W Max</li>
                          </ul>
                        </li>
                      </ul>
                      <hr />
                    </li>
                    <li>
                      AC Input:
                      <ul>
                        <li>
                          <strong>15 A AC Input:</strong> 1,800W Max, 120V, 15A
                          Max, 50/60Hz
                        </li>
                        <li>
                          <strong>AC Input/Output (P050A):</strong>
                          <ul class="circle">
                            <li>Single Unit: 3,200W Max, 120V, 30A Max</li>
                            <li>With Expansion Unit: 3,600W Max</li>
                          </ul>
                        </li>
                        <li>
                          <strong>UPS Switching Time:</strong>
                          <ul class="circle">
                            <li>Apex 200: ≤15ms</li>
                            <li>With Hub A1 System (under load): ≤20ms</li>
                          </ul>
                        </li>
                      </ul>
                      {/* <hr /> */}
                    </li>
                  </ul>
                  {/* <p class="caption">
                    See{" "}
                    <Link
                      external
                      href=""
                    >
                      product manual
                    </Link>{" "}
                    for other countries.
                  </p> */}
                </Fragment>
              ),
            },
            {
              heading: "DC Power",
              content: (
                <Fragment>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      DC Output:
                      <ul>
                        <li>
                          <strong>Total DC Output:</strong> 500W Max
                        </li>
                        <li>
                          <strong>USB Output:</strong>
                          <ul class="circle">
                            <li>
                              USB-C (×1): 140W Max, 5V/3A, 9V/3A, 12V/3A,
                              15V/3A, 20V/5A, 28V/5A
                            </li>
                            <li>
                              USB-C (×1): 100W Max, 5V/3A, 9V/3A, 12V/3A,
                              15V/3A, 20V/5A
                            </li>
                            <li>USB-A (×2): 15W Max, 5V/3A</li>
                          </ul>
                        </li>
                        <li>
                          <strong>Anderson SB50 Port (×1):</strong> 360W Max,
                          12V/30A
                        </li>
                        <li>
                          <strong>Cigarette Lighter Port (×1):</strong> 120W
                          Max, 12V/10A
                        </li>
                      </ul>
                      Note: The cigarette lighter port and the Anderson Port are
                      connected in parallel, with a total output of 30A.
                      <hr />
                    </li>
                    <li>
                      DC Input:
                      <ul>
                        <li>
                          <strong>XT60 Port:</strong> 1,000W Max, 12–60V, 25A
                          Max
                        </li>
                        <li>
                          <strong>MC4 Port:</strong> 2,000W Max, 60–280V, 16A
                          Max
                        </li>
                        <li>
                          <strong>Short-Circuit Current (MC4 Port):</strong> 20A
                        </li>
                      </ul>
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Battery",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Rated Capacity:</strong> 2,560Wh (51.2V/50Ah)
                    </li>
                    <li>
                      <strong>Battery Chemistry:</strong> Lithium Iron Phosphate
                      (LiFePO4, LFP)
                    </li>
                    {/* <li>
                      <strong>Cycle life:</strong> 3,000+ Cycles to 80% Original
                      Capacity
                    </li>
                    <li>
                      <strong>Shelf-life:</strong> Recharge to 40%-60% Every 3-6
                      Months
                    </li>
                    <li>
                      <strong>Management System:</strong> MPPT Controller, BMS,
                      etc
                    </li> */}
                  </ul>
                  <hr />
                  <p>Battery Expansion Port:</p>
                  <ul>
                    <li>
                      <strong>Rated Voltage:</strong> 51.2V
                    </li>
                    <li>
                      <strong>Max Charge Current:</strong> 55A
                    </li>
                    <li>
                      <strong>Max Discharge Current:</strong> 75A
                    </li>
                    <li>
                      <strong>Port Type:</strong> P090A
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Environmental Temperature",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    {/* <li>
                      <strong>Optimal Operating Temperature:</strong> 68° to
                      86°F (20° to 30°C)
                    </li> */}
                    <li>
                      <strong>Charging Temperature:</strong> 32°F to 104°F (0°C
                      to 40°C)
                    </li>
                    <li>
                      <strong>Discharging Temperature:</strong> -4°F to 104°F
                      (-20°C to 40°C)
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong> -4°F to 104°F (-20°C
                      to 40°C)
                    </li>
                    <li>
                      <strong>Working Humidity:</strong> 10% to 90%
                    </li>
                    <li>
                      <strong>Noise:</strong> 50dB Max
                    </li>
                    <li>
                      <strong>Protection Rating:</strong> IP20
                    </li>
                    <li>
                      <strong>Working Altitude:</strong> 6,561ft (2,000m)
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Communications",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>WiFi:</strong>
                      <ul class="circle">
                        <li>Operating Frequency: 2,412MHz～2,472MHz</li>
                        <li>Maximum Transmit Power: ≤20dBm</li>
                        <li>
                          Modulation Mode: DBPSK/DQPSK/CCK/BPSK/QPSK/16QAM/64QAM
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Bluetooth (BLE5.0):</strong>
                      <ul class="circle">
                        <li>Operating Frequency: 2,402MHz～2,480MHz</li>
                        <li>Maximum Transmit Power: ≤10dBm</li>
                        <li>Modulation Mode: GFSK</li>
                      </ul>
                    </li>
                    <li>
                      <strong>USB HID:</strong> Not Supported
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />

        <SlugHeading tag="h3">Apex 300 Comparison</SlugHeading>
        <p>
          The{" "}
          <strong>
            <ProductLink brand="BLUETTI" model="Apex 300" />
          </strong>
          's biggest advantages are its{" "}
          <strong>50A outlet with 120V/240V split-phase capability</strong>,{" "}
          <strong>higher 3,840W AC output</strong>, and{" "}
          <strong>fourth 20A AC outlet</strong>. However, the Apex 200
          introduces a significantly more capable solar charging system,
          combining a dedicated 2,000W high-voltage MPPT (60-280V) with a
          separate 1,000W low-voltage MPPT (12-60V) for up to 3,000W of total
          solar input. It also integrates several functions that require
          additional accessories on the Apex 300, including USB ports, a 12V
          cigarette socket, and a 12V/30A Anderson output. The Apex 200 can also
          be directly linked with another Apex 200 or Apex 300, while BLUETTI
          confirmed that two Apex 300 units cannot currently be directly linked.
          Unless you specifically need 120V/240V power, a 50A outlet, or maximum
          AC output, the Apex 200 will likely be the more practical option for
          most users.
        </p>

        <hr />

        <SlugHeading tag="h3">Elite 300 Comparison</SlugHeading>
        <p>
          <strong>
            The Apex 200 offers several meaningful advantages over the{" "}
            <ProductLink brand="BLUETTI" model="Elite 300" />
          </strong>
          , including higher AC output, more solar input, battery expansion, and
          full Charger 2 ecosystem support. Its dedicated 2,000W high-voltage
          MPPT (60-280V) and separate 1,000W low-voltage MPPT (12-60V) provide
          up to 3,000W of total solar input while supporting a wider range of
          solar configurations. The Elite 300 counters with a{" "}
          <strong>fourth 20A AC outlet</strong>,{" "}
          <strong>slightly higher built-in battery capacity</strong>, and{" "}
          <strong>slightly lower weight</strong>. For most people, the Apex 200
          will be the more capable and versatile power station.
        </p>

        <hr />

        <p>
          Existing{" "}
          <strong>
            <ProductLink brand="BLUETTI" model="AC200L" />
          </strong>{" "}
          and{" "}
          <strong>
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/ac200p-l"
            >
              AC200PL
            </Link>
          </strong>{" "}
          owners may also find the Apex 200 to be a compelling upgrade,
          combining familiar expansion capabilities with higher AC output and a
          more flexible solar charging system.
        </p>
      </Center>

      <Center>
        <SlugHeading tag="h2">Launch Pricing</SlugHeading>
        <p>
          BLUETTI has announced the following launch pricing for the Apex 200:
        </p>

        <Promo
          affiliateData={affiliateMerchants.bluetti}
          href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
        />

        <p>
          Previous BLUETTI launches suggest the price may increase further once
          the launch promotion ends.
        </p>

        <BluettiCouponCode
          mini
          href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
          buttonText="Buy from BLUETTI"
        />

        <p class="caption-left">
          Pricing and promotions are subject to change. Check{" "}
          <Link
            affiliateData={affiliateMerchants.bluetti}
            href="https://www.bluettipower.com/"
          >
            BLUETTI
          </Link>{" "}
          for the latest pricing and availability.
        </p>
      </Center>

      <Center>
        <SlugHeading tag="h2">Highlights</SlugHeading>
        <ul>
          <li>
            <strong>Built-In USB Ports:</strong> USB ports are integrated
            directly into the Apex 200. It includes two USB-C ports (100W and
            140W) alongside two 15W USB-A ports for charging phones, tablets,
            cameras, and laptops.
          </li>
          <li>
            <strong>12V/30A Anderson Output:</strong> Uses an Anderson SB50
            connection, providing a straightforward way to power a fuse block or
            high-current 12V equipment.
          </li>
          <li>
            <strong>Dual High/Low Voltage Solar Inputs:</strong> Supports up to
            3,000W of solar input. It splits this across a 2,000W high-voltage
            MPPT input (60-280V⎓16A) using MC4 connectors and a 1,000W
            low-voltage MPPT input (12-60V⎓25A) using a standard XT60
            connection.
          </li>
          <li>
            <strong>Modular Battery Expansion:</strong> Starts at 2.56kWh and
            expands to over 33kWh with up to six expansion batteries. Using the
            optional{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/hub-a1-parallel-box?variant=47353605652699"
            >
              Hub A1
            </Link>
            , up to three Apex 200 systems can be combined for nearly 100kWh of
            total capacity.
          </li>
          <li>
            <strong>Charger 2 Compatibility:</strong> Unlike some BLUETTI power
            stations, the Apex 200 fully supports the{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/bluetti-charger-2-alternator-solar-charger"
            >
              Charger 2
            </Link>{" "}
            ecosystem, including alternator charging while driving,
            bidirectional charging, and DC Hub integration.
          </li>
          <li>
            <strong>12V Cigarette Socket:</strong> Includes a standard 12V/10A
            output for powering common accessories such as portable
            refrigerators, tire inflators, and other 12V equipment.
          </li>
          <li>
            <strong>UPS Switchover Time:</strong> Rated for ≤15ms switchover
            time, making it suitable for computers and other sensitive
            electronics.
          </li>
          <li>
            <strong>Independent Smart Outlets:</strong> Each AC outlet can be
            controlled individually through the BLUETTI app, Amazon Alexa,
            Google Home, or Home Assistant. Green indicator lights make it easy
            to identify active outlets at a glance.
          </li>
          <li>
            <strong>Connecting Units:</strong> Supports linking two Apex 200
            units together or an Apex 200 and an{" "}
            <ProductLink brand="BLUETTI" model="Apex 300" />. Unlike traditional
            expansion batteries, each connected unit remains a fully functional
            power station with its own AC outputs, DC outputs, solar inputs, and
            charging capabilities.
          </li>
          {/* <li>
            <strong>Cooling Fans:</strong>{" "}
            <mark>
              The fans become noticeable under heavier loads and charging, but
              noise levels have been reasonable overall.
            </mark>
          </li> */}
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Considerations</SlugHeading>
        <ul>
          <li>
            <strong>No 240V Output:</strong> The biggest missing feature for
            home backup is the lack of 240V split-phase output. This limits
            compatibility with well pumps, central air conditioners, and other
            high-power household loads.
          </li>
          <li>
            <strong>AC Charging Speed:</strong> The Apex 200 is rated to charge
            at up to 1,800W from a 20A household outlet using the included
            cable. On my unit, however, charging gradually ramps up and tops out
            at about 1,560W even with charging limits adjusted to maximum in the
            BLUETTI app. I've reported the issue to BLUETTI. For comparison, my
            EcoFlow DELTA 3 Max reaches about 1,755W almost immediately on the
            same outlet.
          </li>
          <li>
            <strong>MC4 Connector Durability:</strong> Built-in MC4 connectors
            provide direct compatibility with most solar panels. However, MC4
            connectors are rigid and prone to breaking under stress, so care
            should be taken to protect the built-in ports. Additionally,
            mixed-brand MC4 connections are generally discouraged, especially in
            higher-voltage solar arrays.
          </li>
          <li>
            <strong>XT60 Overheating Concerns:</strong> XT60 connectors are
            common and inexpensive, but overheating failures have been reported
            across many power station brands, even on lower-current ports. With
            the Apex 200 supporting up to 25A through its XT60 solar input,
            connection quality becomes increasingly important.
          </li>
          <li>
            <strong>Clearance Requirements:</strong> Airflow requirements on
            both sides, combined with front-mounted connections, effectively
            require three open sides around the unit. This can complicate
            tighter installations.
          </li>
          <li>
            <strong>Front Port Placement:</strong> Frequently used USB ports
            share space with long-term connections such as the XT60 solar input
            and Anderson DC output. This can make the USB ports less convenient
            to access and contribute to front-panel clutter.
          </li>
          <li>
            <strong>Limited AC Outlets:</strong> Despite supporting 3,600W of AC
            output, the Apex 200 includes only three standard 20A AC outlets.
            Most competing power stations in this size and power class include
            four or more.
          </li>
          <li>
            <strong>Display Brightnes:</strong> The built-in display is on the
            dim side and can be difficult to read in bright conditions.
            Unfortunately, there is no way to adjust its brightness. The AC
            outlet indicator lights can be adjusted, but they remain fairly dim
            even at their highest setting.
          </li>
          <li>
            <strong>No USB HID Support:</strong> The Apex 200 functions as an
            uninterruptible power supply (UPS), but it doesn't support USB HID
            signaling for shutting down connected computers during extended
            outages.
          </li>
          <li>
            <strong>Hub A1 Compatibility:</strong> Apex 200 and{" "}
            <ProductLink brand="BLUETTI" model="Apex 300" /> units can be linked
            directly together, but they cannot be combined within the same{" "}
            <Link
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/hub-a1-parallel-box?variant=47353605652699"
            >
              Hub A1
            </Link>{" "}
            installation. This limits upgrade options for Apex 300 owners
            interested in adding an Apex 200 for its high-voltage solar input,
            integrated USB ports, or 12V DC outputs.
          </li>
        </ul>

        <AffiliateAd brand="BLUETTI" size="leaderboard" />
      </Center>

      <Center>
        <div class={style.skipSection}>
          <SlugLink text="Apex 200 for Vanlife, RV, and Overlanding">
            Skip Section <span class={style.icon} />
          </SlugLink>
        </div>

        <SlugHeading tag="h2">Apex 200 for Home Backup</SlugHeading>

        <ImageSet
          size={4}
          shadow
          images={[
            {
              lg: "/images/products/bluetti/apex-200/photos/hub-a1-system.webp",
              alt: "BLUETTI Apex 200 and Hub A1 connected to house breaker panel",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/on-cabinet.webp",
              alt: "BLUETTI Apex 200 sitting on cabinet",
            },
          ]}
        />
        <p>
          The Apex 200 offers an{" "}
          <strong>
            impressive blend of capability, portability, and scalability
          </strong>{" "}
          for home backup use. It can serve as a standalone portable power
          station, a generator replacement for selected household circuits, or
          the foundation of a much larger expandable home backup system.
        </p>
        <p>
          A standalone unit provides backup power{" "}
          <strong>wherever it's needed</strong>, whether in{" "}
          <strong>another room</strong>, at a{" "}
          <strong>different property</strong>, or <strong>while camping</strong>
          . At nearly <strong>60 pounds</strong>, some people will need a cart
          or an extra set of hands to move it.
        </p>
        <p>
          Expansion options include <strong>expansion batteries</strong>, a{" "}
          <strong>directly linked Apex 200 or 300</strong>, or{" "}
          <strong>multi‑unit Hub A1 integration</strong>. The table below
          outlines how each option scales <strong>battery capacity</strong> and{" "}
          <strong>AC output</strong>.
        </p>

        <Fragment>
          <FixedTable>
            <table>
              <thead>
                <tr>
                  <th class={editorialStyle.sticky}>Expansion Option</th>
                  <th>Total Battery Capacity</th>
                  <th>Max Single AC Output</th>
                  <th>Total AC Output</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>Apex 200</strong> <br />
                    <span class={style.dimSmall}>Standalone</span>
                  </th>
                  <td>
                    <strong>2.6kWh</strong>
                  </td>
                  <td>
                    <strong>3,200W</strong>
                  </td>
                  <td>
                    <strong>3,200W</strong>
                  </td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>B300K Battery</strong>{" "}
                    <div class={style.dimSmall}>2,764Wh each</div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>5.3kWh</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>19.1kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>1 to 6 batteries</div>
                  </td>
                  <td>
                    <strong class={style.increaseText}>3,600W</strong>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 400W
                    </div>
                  </td>
                  <td>
                    <strong class={style.increaseText}>3,600W</strong>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 400W
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>B500K Battery</strong>{" "}
                    <div class={style.dimSmall}>5,120Wh each</div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>7.7kWh</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>33.3kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>1 to 6 batteries</div>
                  </td>
                  <td>
                    <strong class={style.increaseText}>3,600W</strong>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 400W
                    </div>
                  </td>
                  <td>
                    <strong class={style.increaseText}>3,600W</strong>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 400W
                    </div>
                  </td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Linked Apex 200</NoWrap>
                    </strong>{" "}
                    <div class={style.dimSmall}>Directly linked</div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>5.1kWh</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>30.7kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>0 to 5 batteries</div>
                  </td>
                  <td>
                    <strong class={style.increaseText}>3,600W</strong>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 400W
                    </div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>7,200W</strong>{" "}
                      <sup>1</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 4,000W
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      <NoWrap>Linked Apex 300</NoWrap>
                    </strong>{" "}
                    <div class={style.dimSmall}>
                      Directly linked <sup>5</sup>
                    </div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>5.3kWh</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>30.9kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>0 to 5 batteries</div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>3,840W</strong>{" "}
                      <sup>2</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 640W
                    </div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>7,440W</strong>{" "}
                      <sup>1</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 4,240W
                    </div>
                  </td>
                </tr>

                <tr class={editorialStyle.rowBorder}>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      Hub A1 + <NoWrap>Apex 200 (x2)</NoWrap>
                    </strong>{" "}
                    <div class={style.dimSmall}>2 parallel units</div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>5.1kWh</strong> to{" "}
                      <strong class={style.increaseText}>66.6kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>0 to 12 batteries</div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>6,000W</strong>{" "}
                      <sup>3</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 2,800W
                    </div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>6,400W</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>7,200W</strong>{" "}
                      <sup>1</sup> <sup>4</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 3,200W{" "}
                      <span class={style.dim}>to</span> 4,000W
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class={editorialStyle.sticky}>
                    <strong>
                      Hub A1 + <NoWrap>Apex 200 (x3)</NoWrap>
                    </strong>{" "}
                    <div class={style.dimSmall}>3 parallel units</div>
                  </th>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>7.7kWh</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>99.8kWh</strong>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>0 to 18 batteries</div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>6,000W</strong>{" "}
                      <sup>3</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 2,800W
                    </div>
                  </td>
                  <td>
                    <NoWrap>
                      <strong class={style.increaseText}>9,600W</strong>{" "}
                      <span class={style.dim}>to</span>{" "}
                      <strong class={style.increaseText}>10,800W</strong>{" "}
                      <sup>1</sup> <sup>4</sup>
                    </NoWrap>{" "}
                    <div class={style.dimSmall}>
                      <span class={style.iconUp} /> 6,400W{" "}
                      <span class={style.dim}>to</span> 7,600W
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </FixedTable>
          <p class="caption">
            <strong>1.</strong> Total output is distributed across the separate
            front-facing AC outputs of each power station. <strong>2.</strong>{" "}
            Uses the maximum single output on the <NoWrap>Apex 300</NoWrap>.{" "}
            <strong>3.</strong> Uses the maximum single output on the{" "}
            <NoWrap>Hub A1</NoWrap>. <strong>4.</strong> Requires expansion
            batteries, AC input, or solar power to reach the maximum per-unit
            output. <strong>5.</strong> BLUETTI confirmed that two Apex 300
            units cannot currently be directly linked. Future support remains
            unconfirmed.
          </p>
        </Fragment>

        <SlugHeading tag="h3">Home Integration</SlugHeading>
        <p>
          Integrating the Apex 200 into home wiring can involve a generator{" "}
          <strong>inlet box</strong> with a <strong>transfer switch</strong> or{" "}
          <strong>interlock kit</strong>, a critical loads{" "}
          <strong>sub-panel</strong>, and/or a{" "}
          <strong>multi-unit Hub A1 system</strong>. An{" "}
          <strong>external generator</strong> can extend runtime, while optional{" "}
          <strong>30A and 50A charging cables</strong> provide fast AC
          recharging options. These components can be{" "}
          <strong>combined in several ways</strong> based on household loads,
          runtime needs, and the desired level of integration.
        </p>

        <Accordion
          right
          items={[
            {
              preview: (
                <AccordionPreview
                  headingAs="h3"
                  prefix="Parallel Connection"
                  heading="Hub A1 Package"
                  src="/images/products/bluetti/accessories/hub-a1.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    The Hub A1 allows{" "}
                    <strong>up to three Apex 200 units</strong> to operate
                    together as a single system, increasing total output to{" "}
                    <strong>6,000W</strong> while supporting nearly{" "}
                    <strong>100kWh</strong> of combined storage capacity. This
                    allows homeowners to start small and expand over time rather
                    than replacing their entire backup system as energy
                    requirements grow. When connected through the Hub A1,
                    transfer time under load increases to <strong>≤20ms</strong>{" "}
                    from ≤15ms.
                  </p>
                  <ButtonList>
                    <Button
                      affiliateData={affiliateMerchants.bluetti}
                      href="https://www.bluettipower.com/products/hub-a1-parallel-box?variant=47353605652699"
                      icon="Bluetti"
                    >
                      Buy from BLUETTI
                    </Button>
                    <Button
                      affiliate="https://link.amazon/B0aqUNAa7"
                      href="https://www.amazon.com/dp/B0FJFM1694/"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
          ]}
        />

        <p>
          The <strong>lack of 240V split-phase</strong> (US model) limits
          compatibility with some household loads. However, for standard 120V
          loads, the Apex 200 offers a flexible path from portable emergency
          power to a much larger integrated system.
        </p>
      </Center>

      <Center>
        <div class={style.skipSection}>
          <SlugLink text="Accessories">
            Skip Section <span class={style.icon} />
          </SlugLink>
        </div>

        <SlugHeading tag="h2">
          Apex 200 for Vanlife, RV, and Overlanding
        </SlugHeading>

        <ImageSet
          size={4}
          shadow
          images={[
            {
              lg: "/images/products/bluetti/apex-200/photos/charger-2-system.webp",
              alt: "BLUETTI Apex 200 and Charger 2 in back of vehicle",
            },
            {
              lg: "/images/products/bluetti/apex-200/photos/camper-inlet.webp",
              alt: "BLUETTI Apex 200 powering RV",
            },
          ]}
        />

        <p>
          The Apex 200's combination of{" "}
          <strong>
            integrated 12V DC output, expandable capacity, and flexible charging
            options
          </strong>{" "}
          makes it particularly well suited for mobile power applications.
          Whether you're building a simple weekend camping setup or a more
          capable off-grid electrical system, it offers several features that
          are often missing from traditional portable power stations.
        </p>
        <p>
          One of the most significant additions is the{" "}
          <strong>built-in 12V/30A Anderson output</strong>. When paired with a{" "}
          <strong>fuse block</strong>, it provides a straightforward way to
          power refrigerators, diesel heaters, water pumps, lighting circuits,
          ventilation fans, and other common <strong>12V accessories</strong>.
          This allows the Apex 200 to function more like a traditional RV or van
          electrical system without requiring a separate house battery bank.
        </p>
        <p>
          Charging flexibility is another major advantage. The dedicated{" "}
          <strong>high-voltage and low-voltage solar inputs</strong> support a
          wide range of solar configurations, while the low-voltage input can
          also be used with products such as the Charger 1 and other alternator
          charging systems. Combined with{" "}
          <strong>full Charger 2 ecosystem support</strong> and expansion
          battery compatibility, the{" "}
          <ProductLink brand="BLUETTI" model="Apex 200" /> offers multiple paths
          for increasing capacity and charging performance as your needs evolve.
        </p>

        <ReviewItem href={namedRoutes.bluetti.vanlife} />

        <p>
          For hidden installations, the optional{" "}
          <Link
            affiliateData={affiliateMerchants.bluetti}
            href="https://www.bluettipower.com/products/bluetti-display-1?id=6a4c7c90048ec316cd178969&variant=48949698167003"
          >
            Display 1
          </Link>{" "}
          provides remote system monitoring, but control still requires the
          BLUETTI app or physical access to the Apex 200.
        </p>

        <hr />

        <SlugHeading tag="h3">Vanlife & RV System Examples</SlugHeading>
        <p>
          The following diagrams illustrate some of the key ecosystem
          differences between the{" "}
          <ProductLink brand="BLUETTI" model="Apex 200" />,{" "}
          <ProductLink brand="BLUETTI" model="Apex 300" />, and{" "}
          <ProductLink brand="BLUETTI" model="Elite 300" /> in vehicle-based
          applications.
        </p>
        <ImageSet
          size={3}
          images={[
            {
              lg: "/images/diagrams/power-systems/bluetti/bluetti-apex-200.webp?v=2",
              alt: "BLUETTI Apex 200 vanlife system diagram",
            },
            {
              lg: "/images/diagrams/power-systems/bluetti/bluetti-apex-300.webp?v=2",
              alt: "BLUETTI Apex 300 vanlife system diagram",
            },
            {
              lg: "/images/diagrams/power-systems/bluetti/bluetti-elite-300.webp?v=2",
              alt: "BLUETTI Elite 300 vanlife system diagram",
            },
          ]}
        />
      </Center>

      <Center>
        <SlugHeading tag="h2">Accessories</SlugHeading>

        <SlugHeading tag="h3">Extra Batteries</SlugHeading>
        <p>
          Supports up to <strong>six expansion batteries</strong>, increasing
          total storage capacity to <strong>over 33kWh</strong>:
        </p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/b500k-expansion-battery?id=691186b04abc44066f33eb59&variant=47893756903643"
              img="/images/products/bluetti/b500k/front.webp"
              title="BLUETTI B500K"
              titleSuffix="(supports 6x)"
              description={<Fragment>5,120Wh</Fragment>}
              buttonText="BLUETTI"
              buttonIcon="Bluetti"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.bluetti}
              href="https://www.bluettipower.com/products/b300k?id=6879b82863e18b529ef25f0b&variant=47262756896987"
              img="/images/products/bluetti/b300k/front.webp"
              title="BLUETTI B300K"
              titleSuffix="(supports 6x)"
              description={<Fragment>2,764Wh</Fragment>}
              buttonText="BLUETTI"
              buttonIcon="Bluetti"
            />
          </li>
        </ul>
        <p class="caption-left">
          <strong>Cable Types:</strong> When ordering an expansion battery,
          select the AC300/200L option if you want a longer connection cable.
          The Apex 300 variant includes a shorter cable meant for tight
          stacking.
        </p>
        <Accordion
          left
          headingsAs="h4"
          items={[
            {
              heading: "Battery Cable Options",
              content: (
                <Fragment>
                  <p>
                    A cable comes bundled with every battery, and both styles
                    are sold separately if you need one.
                  </p>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/p090a-battery-expansion-cable?variant=47477775991003"
                        img="/images/products/bluetti/accessories/p090a-battery-cable.webp"
                        title="P090A Battery Expansion Cable"
                        description={
                          <Fragment>
                            2.6ft cable for flexible placement
                          </Fragment>
                        }
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/external-battery-connection-cable-ca90"
                        img="/images/products/bluetti/accessories/ca90-battery-cable.webp"
                        title="CA90 External Battery Connection Cable"
                        description={
                          <Fragment>
                            Short, rigid cable for stacked setups
                          </Fragment>
                        }
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Discontinued Battery Options",
              content: (
                <Fragment>
                  <p>
                    These legacy battery options are also compatible, allowing
                    existing batteries to be reused for additional capacity.
                  </p>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/b300"
                        img="/images/products/bluetti/b300/front.webp"
                        title="B300"
                        titleSuffix="(supports 2x)"
                        description={<Fragment>3,072Wh</Fragment>}
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/bluetti-b300s-expansion-battery"
                        img="/images/products/bluetti/b300s/front.webp"
                        title="B300S"
                        titleSuffix="(supports 2x)"
                        description={<Fragment>3,072Wh</Fragment>}
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
        {/* <p class="caption-left">
          <strong>Note:</strong> The Apex 200 manual also references B300 Pro
          and B500 Pro batteries. BLUETTI indicated these models are not
          expected to launch this year, and specifications have not yet been
          released.
        </p> */}

        <br />

        <SlugHeading tag="h3">AC Charging Accessories</SlugHeading>
        <p>
          Optional AC charging cables allow the Apex 200 to charge directly from
          common 30A and 50A RV shore power hookups:
        </p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.bluetti}
              //href="https://www.bluettipower.com/products/apex300-fast-ac-charging-cable?variant=47351584063707"
              img="/images/products/bluetti/accessories/nema-tt-30p-to-p050a.webp?v=2"
              title="AC Charging Cable"
              titleSuffix="(30A)"
              description={<Fragment>NEMA TT-30P to P050A </Fragment>}
              buttonText="BLUETTI"
              buttonIcon="Bluetti"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.bluetti}
              //href="https://www.bluettipower.com/products/apex300-fast-ac-charging-cable?variant=47351584030939"
              img="/images/products/bluetti/accessories/nema-14-50p-to-p050a.webp?v=2"
              title="AC Charging Cable"
              titleSuffix="(50A)"
              description={<Fragment>NEMA 14-50P to P050A</Fragment>}
              buttonText="BLUETTI"
              buttonIcon="Bluetti"
            />
          </li>
        </ul>

        <br />

        <SlugHeading tag="h3">Alternator Chargers</SlugHeading>
        <p>
          Alternator charging is one of the fastest and most reliable ways to
          recharge a power station while driving. It often outperforms solar and
          isn’t dependent on sunshine or good weather. BLUETTI currently offers
          two alternator chargers:{" "}
          <Link
            affiliateData={affiliateMerchants.bluetti}
            href="https://www.bluettipower.com/products/bluetti-charger-2-alternator-solar-charger"
          >
            Charger 2
          </Link>{" "}
          and{" "}
          <Link
            affiliateData={affiliateMerchants.bluetti}
            href="https://www.bluettipower.com/products/bluetti-charger-1"
          >
            Charger 1
          </Link>
          . These units pull power from your vehicle to charge your power
          station, similar to a DC-DC charger.
        </p>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.bluetti.charger2.review} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.bluetti.charger1.review} />
          </li>
        </ul>

        <Accordion
          left
          headingsAs="h4"
          items={[
            {
              heading: "Alternative Option: Car Charging Cable",
              content: (
                <Fragment>
                  <p>
                    An alternative option is charging from a vehicle cigarette
                    lighter socket via the XT60 solar port, though most 12V
                    outlets limit output to about 100W. However, some vehicle
                    cigarette sockets aren't designed for continuous heavy
                    loads, which can overheat the socket or blow a fuse.
                  </p>
                  <PhotoListItem
                    affiliateData={affiliateMerchants.bluetti}
                    href="https://www.bluettipower.com/products/ac2a-car-charging-cable"
                    img="/images/products/bluetti/accessories/cigarette-to-xt60-charging-cable.webp"
                    title="Car Charging Cable"
                    description={
                      <Fragment>
                        XT60 to Cigarette <br />
                        196W max
                      </Fragment>
                    }
                    buttonText="BLUETTI"
                    buttonIcon="Bluetti"
                  />
                </Fragment>
              ),
            },
          ]}
        />

        <p>
          <strong>Unsure which charger to get?</strong> My{" "}
          <Link href={namedRoutes.alternatorChargers}>
            alternator charger guide
          </Link>{" "}
          covers all the popular brands.
        </p>

        <br />

        <SlugHeading tag="h3">DC Expansion & Fuse Block</SlugHeading>
        <p>
          The built-in <strong>12V/30A Anderson SB50 output</strong> can be
          connected to a <strong>fuse block</strong>, providing a simple way to
          distribute power to refrigerators, diesel heaters, water pumps,
          lighting circuits, ventilation fans, and other common 12V accessories.
          The cable and fuse block shown below are examples of components that
          can be used to create a 12V distribution system.
        </p>

        <Accordion
          right
          items={[
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Anderson SB50 to ring terminal"
                  heading="6 AWG Cable"
                  src="/images/products/assorted/cables/anderson-sb50-ring-terminal.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    This cable allows you to safely connect a DC fuse block to
                    the Apex 200’s or DC Hub’s Anderson SB50 port without making
                    your own cable. This pre-made kit saves you from needing
                    specialized crimping tools.
                  </p>

                  <p>
                    <strong>Length:</strong> 23in
                    <br />
                    <strong>Gauge:</strong> 6AWG
                    <br />
                    <strong>Fuse Type:</strong> MEGA
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/4m2xgW6"
                      href="https://www.amazon.com/dp/B0FH1GDVKL/"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
            {
              preview: (
                <AccordionPreview
                  headingAs="h4"
                  prefix="Fuse block"
                  heading="Blue Sea Systems 5026 Fuse Block"
                  src="/images/products/blue-sea-systems/5026.webp"
                />
              ),
              content: (
                <Fragment>
                  <p>
                    There is also a 6 circuit model available (
                    <Link
                      affiliate="https://amzn.to/43tntjR"
                      href="https://www.amazon.com/dp/B000THQ0CQ"
                    >
                      5025
                    </Link>
                    ), but it's nice to have room to add extra circuits in the
                    future.
                  </p>
                  <p>
                    <strong>Model:</strong> 5026
                    <br />
                    <strong>Circuits:</strong> 12
                    <br />
                    <strong>Max Amperage:</strong> 30A per circuit (100A total)
                    <br />
                    <strong>Max Voltage:</strong> 32V DC
                    <br />
                    <strong>Fuse Type:</strong> ATO® or ATC®
                  </p>
                  <p>
                    You will also need to purchase the appropriate fuses to
                    match the wiring of your circuits. These can be purchased{" "}
                    <Link
                      affiliate="https://amzn.to/4oLUFvA"
                      href="https://www.amazon.com/dp/B00FLZRJJO"
                    >
                      individually
                    </Link>{" "}
                    or in a{" "}
                    <Link
                      affiliate="https://amzn.to/4r0jiGd"
                      href="https://www.amazon.com/dp/B00CQ8ILFA"
                    >
                      multi-pack
                    </Link>
                    . Be sure to use a reputable brand, as properly rated fuses
                    help prevent electrical fires.
                  </p>
                  <ButtonList>
                    <Button
                      affiliate="https://amzn.to/4qXtEXd"
                      href="https://www.amazon.com/dp/B001P6FTHC"
                      icon="Amazon"
                      secondary
                    >
                      Buy on Amazon
                    </Button>
                  </ButtonList>
                </Fragment>
              ),
            },
          ]}
        />

        <h4>50A DC Expansion Options</h4>
        <p>
          The built-in Anderson SB50 output supports up to{" "}
          <strong>30A of 12V DC power</strong>. Users who need additional DC
          outputs or higher-current DC distribution can expand the system to 50A
          using either of the options shown below. Both approaches expand the
          Apex 200 to 50A DC output while adding additional USB, DC, and
          cigarette socket outputs with support for either 12V or 24V operation.
        </p>
        <Accordion
          left
          headingsAs="h5"
          items={[
            {
              heading: "Option 1: Charger 2 + DC Hub",
              content: (
                <Fragment>
                  <p>
                    Recommended for users who want both{" "}
                    <strong>50A DC expansion and alternator charging</strong>{" "}
                    through the Charger 2 ecosystem:
                  </p>
                  <Accordion
                    right
                    items={[
                      {
                        preview: (
                          <AccordionPreview
                            headingAs="h6"
                            prefix="DC Output"
                            heading="BLUETTI DC Hub"
                            src="/images/products/bluetti/charger-2/dc-hub.webp"
                          />
                        ),
                        content: (
                          <Fragment>
                            <p>
                              The BLUETTI DC Hub paired with the BLUETTI Charger
                              2 unlocks the Apex 200’s full 50A DC output
                              capability, adding two USB-C ports, two USB-A
                              ports, two DC5521 ports, two 12V cigarette
                              sockets, a 50A Anderson SB50 port, and support for
                              either 12V or 24V operation.
                            </p>

                            <ButtonList>
                              <Button
                                affiliateData={affiliateMerchants.bluetti}
                                href="https://www.bluettipower.com/products/dc-hub-for-charger-2"
                                icon="Bluetti"
                              >
                                Buy from BLUETTI
                              </Button>
                            </ButtonList>
                          </Fragment>
                        ),
                      },
                      {
                        preview: (
                          <AccordionPreview
                            headingAs="h6"
                            prefix="Alternator Charger"
                            heading="BLUETTI Charger 2"
                            src="/images/products/bluetti/charger-2/front.webp"
                          />
                        ),
                        content: (
                          <Fragment>
                            <p>
                              The Apex 200 can be charged from your vehicle
                              using BLUETTI’s Charger 2, which provides up to
                              800W of alternator charging through the
                              bidirectional port. This is the recommended option
                              for vanlife because it supports full DC Hub
                              functionality while leaving the low-voltage solar
                              input available for solar panels or other charging
                              sources.
                            </p>

                            <ReviewItem
                              href={namedRoutes.bluetti.charger2.review}
                            />

                            <ButtonList>
                              <Button
                                affiliateData={affiliateMerchants.bluetti}
                                href="https://www.bluettipower.com/products/bluetti-charger-2-alternator-solar-charger"
                                icon="Bluetti"
                              >
                                Buy from BLUETTI
                              </Button>
                              <Button
                                affiliate="https://amzn.to/4q6J9LD"
                                href="https://www.amazon.com/dp/B0FS7C11QG/"
                                icon="Amazon"
                                secondary
                              >
                                Buy on Amazon
                              </Button>
                            </ButtonList>
                          </Fragment>
                        ),
                      },
                    ]}
                  />
                </Fragment>
              ),
            },
            {
              heading: "Option 2: Hub D1",
              content: (
                <Fragment>
                  <p>
                    Provides similar{" "}
                    <strong>
                      50A DC expansion capabilities without requiring a Charger
                      2
                    </strong>
                    , making it a simpler option when alternator charging is not
                    needed:
                  </p>

                  <Accordion
                    right
                    items={[
                      {
                        preview: (
                          <AccordionPreview
                            headingAs="h6"
                            prefix="DC Output"
                            heading="BLUETTI Hub D1"
                            src="/images/products/bluetti/accessories/hub-d1.webp"
                          />
                        ),
                        content: (
                          <Fragment>
                            <p>
                              The BLUETTI Hub D1 unlocks the Apex 200's full 50A
                              DC output capability without requiring a Charger
                              2, adding two USB-C ports, two USB-A ports, two
                              DC5521 ports, two 12V cigarette sockets, a 50A
                              Anderson SB50 port, and support for either 12V or
                              24V operation.
                            </p>

                            <ButtonList>
                              <Button
                                affiliateData={affiliateMerchants.bluetti}
                                href="https://www.bluettipower.com/products/hub-d1-parallel-box?id=68d92828c4be42ab9fea703b&variant=48125792649435"
                                icon="Bluetti"
                              >
                                Buy from BLUETTI
                              </Button>
                            </ButtonList>
                          </Fragment>
                        ),
                      },
                    ]}
                  />
                </Fragment>
              ),
            },
          ]}
        />

        <br />

        <SlugHeading tag="h3">External Display</SlugHeading>
        <p>
          For installations where the Apex 200 is stored out of sight, the
          optional Display 1 provides convenient monitoring of battery level,
          power flow, system status, and alerts. Its magnetic back, included
          metal plate, and integrated stand provide flexible placement. Despite
          its touchscreen-like appearance, Display 1 cannot control the power
          station. Controlling outputs and other settings still requires the
          BLUETTI app or physical access to the Apex 200.
        </p>
        <PhotoListItem
          affiliateData={affiliateMerchants.bluetti}
          href="https://www.bluettipower.com/products/bluetti-display-1?id=6a4c7c90048ec316cd178969&variant=48949698167003"
          img="/images/products/bluetti/accessories/display-1.webp"
          title="Display 1"
          description={
            <Fragment>
              Rechargable battery, <br />
              Bluetooth connection
            </Fragment>
          }
          buttonText="BLUETTI"
          buttonIcon="Bluetti"
        />

        <br />

        <SlugHeading tag="h3">Solar Panels</SlugHeading>
        <p>
          <strong>
            The Apex 200 is compatible with both BLUETTI and third-party solar
            panels.
          </strong>{" "}
          Just be sure your solar array remains within the voltage and current
          limits of the selected solar input.
        </p>

        <Accordion
          left
          headingsAs="h5"
          items={[
            {
              heading: "Solar Accessory Cables",
              content: (
                <Fragment>
                  <ul class="none">
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/bluetti-solar-extension-cable?variant=48836183392475"
                        img="/images/products/bluetti/accessories/5m-solar-extension-cable-30a.webp"
                        title="Solar Extension Cable"
                        titleSuffix="(30A)"
                        description={<Fragment>Lengths: 5m and 10m</Fragment>}
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        _href="https://www.bluettipower.com/products/apex300-solar-charging-cable"
                        img="/images/products/bluetti/accessories/apex300-mc4-to-xt60.webp"
                        title="XT60 to MC4 Solar Cable"
                        titleSuffix="(25A)"
                        description={
                          <Fragment>
                            MC4 to XT60 adapter <br />
                            (Availabile soon)
                          </Fragment>
                        }
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/bluetti-xt60-to-mc4-solar-parallel-cable"
                        img="/images/products/bluetti/accessories/parallel-mc4-to-xt60-25a.webp"
                        title="XT60 to MC4 Solar Parallel Cable"
                        titleSuffix="(25A)"
                        description={
                          <Fragment>
                            MC4 parallel adapter for XT60 input
                          </Fragment>
                        }
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                    <li>
                      <PhotoListItem
                        affiliateData={affiliateMerchants.bluetti}
                        href="https://www.bluettipower.com/products/mc4-solar-y-branch-parallel-cable"
                        img="/images/products/bluetti/accessories/mc4-parallel-branch-30a.webp"
                        title="MC4 Solar Connectors Y Branch Parallel Adapter Cable"
                        titleSuffix="(30A)"
                        description={<Fragment>MC4 parallel adapter</Fragment>}
                        buttonText="BLUETTI"
                        buttonIcon="Bluetti"
                      />
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>

      <Center>
        <SlugHeading tag="h2">Suggestions to BLUETTI</SlugHeading>
        <p>A few things I would like to see improved in future models:</p>

        <Accordion
          items={[
            {
              heading: "My Suggestions & Feedback ",
              content: (
                <Fragment>
                  <ul>
                    <li>
                      <strong>Next-Generation Apex 300:</strong> The Apex 200
                      introduces several welcome improvements over the{" "}
                      <ProductLink brand="BLUETTI" model="Apex 300" />,
                      including integrated USB ports, built-in DC outputs, and
                      dedicated high- and low-voltage solar inputs. I'd love to
                      see these improvements carried forward into a future Apex
                      300 revision while retaining support for 120V/240V
                      split-phase output. I'd also like to see a future Apex
                      model further distinguish itself with a capacity increase
                      to the 4-5kWh range.
                    </li>
                    <li>
                      <strong>Higher-Power Anderson Output:</strong> The
                      built-in 12V/30A Anderson SB50 output is one of the Apex
                      200's best features. It would be even more useful if 50A
                      output was available directly from the power station
                      without requiring additional accessories.
                    </li>
                    <li>
                      <strong>Configurable DC Output Voltage:</strong> Allowing
                      users to manually select different output voltages such as
                      12V, 24V, or even 48V would provide significantly more
                      flexibility for powering a wider variety of equipment
                      without relying on external converters.
                    </li>
                    <li>
                      <strong>More AC Outlets:</strong> Three 20A AC outlets
                      feel restrictive on a power station capable of delivering
                      3,200W of continuous output. A fourth outlet would improve
                      flexibility and better align with competing products in
                      this size class.
                    </li>
                    <li>
                      <strong>Display Accessory with Controls:</strong> I’d like
                      to see BLUETTI build on Display 1 by adding basic system
                      controls to a future display accessory. Dedicated AC and
                      DC output buttons would cover the most common needs, while
                      a few app-configurable buttons could provide quick access
                      to personalized functions without the higher power
                      consumption of a full touchscreen.
                    </li>
                    <li>
                      <strong>More USB Ports:</strong> USB ports are
                      increasingly replacing traditional AC adapters, and it's
                      common for a power station to serve as a charging hub for
                      multiple people, each with several devices. I'd like to
                      see future models include at least six USB ports, with
                      four USB-C ports (including at least two 140W ports for
                      laptops and other high-power devices) while retaining two
                      USB-A ports for legacy devices and accessories.
                    </li>
                    <li>
                      <strong>EV Charging Cable:</strong> BLUETTI offers an EV
                      charging cable for the European Apex 200, likely because
                      that version operates at 240V. I'd love to see future US
                      Apex models add support for charging from EV charging
                      stations.
                    </li>
                    <li>
                      <strong>Two Battery Expansion Ports:</strong> A second
                      battery expansion port would provide significantly greater
                      flexibility across the BLUETTI ecosystem. Expansion
                      batteries already include two expansion ports, allowing
                      them to be chained together, while power stations are
                      limited to a single connection. I've seen the Apex 200 and
                      Apex 300 linked together using an expansion cable to share
                      capacity, which is incredibly useful, but doing so
                      consumes the only expansion port and prevents simultaneous
                      use of products such as Charger 2, Hub D1, or future
                      accessories.
                    </li>
                    <li>
                      <strong>Solar Input Connections:</strong> Built-in MC4 and
                      XT60 connections provide direct compatibility with solar
                      panels and accessories, but they also become long-term
                      durability and serviceability concerns if damaged. I'd
                      like to see BLUETTI explore a short replaceable cable
                      approach similar to EcoFlow's new HP500 system (used in
                      TITAN and DELTA Gen4), where wear and tear occurs on an
                      inexpensive cable rather than on the power station itself.
                      This could improve durability, reduce overheating
                      concerns, and make damaged cables easy to replace.
                    </li>
                    <li>
                      <strong>CarPlay & Android Auto Integration:</strong>{" "}
                      Adding CarPlay and Android Auto support would allow users
                      to monitor charging, battery capacity, solar input, and
                      power consumption directly from their vehicle's dashboard
                      while providing quick access to common controls.
                    </li>
                    <li>
                      <strong>Locking 12V Socket:</strong> Traditional cigarette
                      sockets can work loose over time, especially in RV and van
                      applications. I'd like to see a locking marine-style 12V
                      socket for users powering critical loads.
                    </li>
                    <li>
                      <strong>Anderson Connections:</strong> BLUETTI's
                      increasing use of the Anderson SB50 connector across the
                      Apex 200, Charger 2, DC Hub, and Hub D1 is a positive step
                      toward a more unified ecosystem. However, the FridgePower
                      implementation feels inconsistent since the connector is
                      used for connecting the BC200 expansion battery rather
                      than as a 12V/24V DC output. I'd also like to see BLUETTI
                      clearly identify the exact Anderson connector type, as
                      "Anderson" can refer to several different connector
                      families.
                    </li>
                    <li>
                      <strong>USB HID Support:</strong> Adding USB HID support
                      would improve compatibility with desktops, NAS devices,
                      and home servers. Ideally, users could access USB HID
                      functionality through any USB port rather than being
                      limited to a specific connector or giving up a high-power
                      USB charging port.
                    </li>
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>

      <Center>
        <SlugHeading tag="h2">Early Verdict</SlugHeading>
        <p>
          The <strong>BLUETTI Apex 200</strong> fills an important gap in
          BLUETTI's lineup. Rather than simply serving as a smaller{" "}
          <ProductLink brand="BLUETTI" model="Apex 300" />, it combines many of
          the <ProductLink brand="BLUETTI" model="Elite 300" />
          ’s practical features with much of the performance and expandability
          of the Apex 300.
        </p>
        <p>
          Its expandable capacity, integrated 12V outputs, and up to 3,000W of
          solar charging make it particularly promising for home backup,
          vanlife, RV, and off-grid use. While it's substantially smaller and
          lighter than the Apex 300, the lack of 240V split-phase output and
          limited number of AC outlets will matter for some buyers.
        </p>
        <p>
          The Apex 200 is shaping up to be one of BLUETTI’s most well-rounded
          power stations, and I’m looking forward to sharing more of my hands-on
          experience soon.
        </p>

        <p>
          Follow{" "}
          <strong>
            <Link external href="https://www.facebook.com/TysonsGearLab">
              Tyson's Gear Lab
            </Link>
          </strong>{" "}
          on Facebook for the latest news, spec updates, and release
          announcements.{" "}
        </p>

        <BluettiCouponCode
          mini
          href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
          buttonText="Buy from BLUETTI"
        />

        <p>
          <strong>Still unsure?</strong> Compare{" "}
          <Link href={namedRoutes.powerStations}>other power stations</Link>{" "}
          across popular brands.
        </p>

        <ButtonList>
          <Button
            affiliateData={affiliateMerchants.bluetti}
            href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
            icon="Bluetti"
          >
            BLUETTI Apex 200
          </Button>
          {/* <Button
            affiliate="https://amzn.to/3Q6jLIN"
            href="https://www.amazon.com/dp/B0CLGZB3L6/"
            secondary
            icon="Amazon"
          >
            Buy on Amazon
          </Button> */}
        </ButtonList>

        <p class="caption-left">
          This page will be updated as new information becomes available.
        </p>

        <Tags tags={headerInfo.tags} brands={headerInfo.brands} />
      </Center>
      <Center>
        <h3>Related</h3>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.bluetti.vanlife} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.powerSystems} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.alternatorChargers} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.inventory.vanlife} />
          </li>
        </ul>
      </Center>
      <Questions />
      <Center>
        <Author
          author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
      </Center>
      <StickyButtons
        title="BLUETTI Apex 200"
        description={
          <Fragment>
            $1,099 <s>$1,399</s>
          </Fragment>
        }
      >
        <Button
          affiliateData={affiliateMerchants.bluetti}
          href="https://www.bluettipower.com/pages/apex-200-expandable-power-station"
          icon="Bluetti"
        >
          View on BLUETTI
        </Button>
        {/* <Button
          affiliate="https://amzn.to/3Q6jLIN"
          href="https://www.amazon.com/dp/B0CLGZB3L6/"
          secondary
          icon="Amazon"
        >
          View on Amazon
        </Button> */}
      </StickyButtons>
    </Editorial>
  </div>
);

export default Page;
